const darkSkin = {
  "border-separator-color": "#383d3f",
  "table-hover-background": "#2b2f31",
  "input-light-background": "#181a1b",
  "light-background": "#181a1b",
  "dark-background": "#2b2f31",
  "dark-background-text-color": "#e8e6e3",
  "default-background": "#181a1b",
  "default-text-color": "#d1cdc7",
  "emphasis-background-color": "#2394fd",
  "emphasis-text-color": "#ffffff",
  "selected-background-color": "#2684FF",
  "selected-text-color": "#ffffff",
  "unchecked-background-color": "#dddddd",
  "input-background-color": "#333333",
  "box-shadow-primary":
    "0 0 0 1px rgba(255, 255, 255, 0.2), 0 4px 11px rgba(255, 255, 255, 0.2)",
};

export default darkSkin;
